import moment from "moment"

export function addCases(builder, thunk, fulfilled, pending, rejected) {
    if (!builder || !thunk) return

    if (pending) builder.addCase(thunk.pending, pending)
    if (rejected) builder.addCase(thunk.rejected, rejected)
    if (fulfilled) builder.addCase(thunk.fulfilled, fulfilled)
}

export function timestampToLocalDatestring(timestamp)
{
    if (timestamp > 0) {
        const dt = new Date(timestamp * 1000)
        return dt.toLocaleDateString()
    }
    else
        return "Неизвестная дата"
}

export function timeMomentToTimestamp(datetime)
{
    var m = moment(datetime)
    m.utc()
    return m.unix()
}
